// Feriados nacionais do Brasil (fixos + móveis via Páscoa/Butcher) e cálculo de dia útil.

function easterSunday(year) {
  // Algoritmo de Butcher/Meeus
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31); // 3 = março, 4 = abril
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}

export function ymdLocal(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function formatBR(d) {
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
}

const _cache = {};
function holidaysForYear(year) {
  if (_cache[year]) return _cache[year];
  const fixed = ["01-01", "04-21", "05-01", "09-07", "10-12", "11-02", "11-15", "12-25"];
  const set = new Set(fixed.map((md) => `${year}-${md}`));
  const easter = easterSunday(year);
  // Terça de Carnaval (-47), Quarta de Cinzas (-46), Sexta-feira Santa (-2), Corpus Christi (+60)
  for (const off of [-47, -46, -2, 60]) set.add(ymdLocal(addDays(easter, off)));
  _cache[year] = set;
  return set;
}

export function isHoliday(d) {
  return holidaysForYear(d.getFullYear()).has(ymdLocal(d));
}

export function isBusinessDay(d) {
  const wd = d.getDay(); // 0 = domingo, 6 = sábado
  return wd !== 0 && wd !== 6 && !isHoliday(d);
}

// Primeiro dia útil subsequente à data informada (avança dia a dia).
export function nextBusinessDay(from = new Date()) {
  let d = addDays(from, 1);
  while (!isBusinessDay(d)) d = addDays(d, 1);
  return d;
}
